var actions = {
	next: "Dalej",
	confirm: "Potwierdź",
	"continue": "Kontynuuj"
};
var errors = {
	unknown: "Wystąpił nieznany błąd",
	contactSupport: "Wystąpił błąd. Skontaktuj się z pomocą techniczną.",
	tryAgain: "Wystąpił błąd. Spróbuj ponownie.",
	submit: "Wystąpił błąd z Twoim zgłoszeniem."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Zaloguj się za pomocą {name}",
	signupWith: "Zarejestruj się za pomocą {name}"
};
var alreadyHaveAccount = {
	company: "Masz już konto {company}?",
	text: "Masz już Streamlabs ID?",
	link: "Zaloguj się"
};
var noAccount = {
	text: "Nie masz jeszcze konta?",
	link: "Zarejestruj się"
};
var validation = {
	email: {
		invalid: "Podaj prawidłowy adres e-mail"
	},
	password: {
		required: "Hasło jest wymagane",
		min: "Hasło musi mieć więcej niż 8 znaków",
		number: "Hasło musi zawierać cyfrę",
		upper: "Hasło musi zawierać wielką literę",
		special: "Hasło musi zawierać znak specjalny"
	},
	username: {
		invalid: "Nazwa musi zawierać przynajmniej 5 znaków"
	},
	code: {
		minmax: "Kod powinien zawierać od 6 do 10 znaków"
	}
};
var poweredBy = "Dostarczany przez <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Nie znaleziono firmy!",
		desc: "Spróbuj ponownie lub skontaktuj się z pomocą techniczną."
	},
	company: {
		logoAlt: "Logo {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-cyfrowy kod uwierzytelniający/8-cyfrowy kod zapasowy",
	successText: "Sukces! Przekierowywanie…",
	remember: "Zapamiętaj to urządzenia na 30 dni"
};
var createTfa = {
	scan: {
		title: "Włącz uwierzytelnianie dwuskładnikowe",
		lead: "Kliknij/skopiuj lub zeskanuj poniższy kod za pomocą preferowanej aplikacji uwierzytelniającej. Zalecamy korzystanie z takich aplikacji, jak <app0 />, <app1 /> i <app2 />, aby bezpiecznie przechowywać swoje kody.",
		copied: "Skopiowano!",
		instructions: "Lub wprowadź ten kod ręcznie do swojej aplikacji uwierzytelniającej.",
		copy: "Skopiuj kod",
		proceed: "Potwierdzenie"
	},
	confirm: {
		title: "Potwierdź uwierzytelnienie dwuskładnikowe (2FA)",
		lead: "Prześlij wygenerowany poniżej kod 2FA i włącz uwierzytelnianie dwuskładnikowe.",
		label: "Kod uwierzytelniania dwuskładnikowego (6 cyfr)",
		verify: "Zweryfikuj kod",
		next: "Sukces! Kolejny krok"
	},
	save: {
		title: "Zapisz swoje kody odzyskiwania",
		lead: "Zapisz swoje kody odzyskiwania na wypadek, gdybyś stracił dostęp do swojego uwierzytelnienia dwuskładnikowego.. Po zamknięciu tego okna modalnego kody te nie będą już dostępne.",
		label: "Kody odzyskiwania",
		download: "Pobierz kody odzyskiwania",
		copied: "Skopiowano kody!",
		finished: "Zakończono"
	}
};
var emailLoginForm = {
	buttonText: "Zaloguj się",
	emailPlaceholder: "E-mail",
	passwordPlaceholder: "Hasło"
};
var emailSignupForm = {
	buttonText: "Zarejestruj się",
	emailPlaceholder: "Ustaw e-mail",
	passwordPlaceholder: "Ustaw hasło",
	usernamePlaceholder: "Twoja nazwa",
	ageLabel: "Data urodzenia",
	agePlaceholder: "MM.DD.RRRR",
	agreeText: "Akceptuję <terms>Warunki korzystania z usługi</terms> oraz <privacy>Politykę prywatności</privacy> Streamlabs.",
	agreeError: "Zaakceptuj regulamin Streamlabs."
};
var ageInput = {
	invalidDate: "Podaj prawidłową datę urodzenia",
	futureDate: "Data urodzenia musi być w przeszłości",
	minDate: "Daty przed rokiem {year} nie są dozwolone",
	minAge_one: "Musisz mieć co najmniej {years} lat, aby korzystać ze Streamlabs",
	minAge_two: "Musisz mieć co najmniej {years} lat, aby korzystać ze Streamlabs",
	minAge_other: "Musisz mieć co najmniej {years} lat, aby korzystać ze Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mail",
	back: "Powrót do logowania",
	successText: "Sukces! Wysłaliśmy Ci kod do zresetowania hasła",
	buttonText: "Poproś o e-mail do resetowania",
	create: {
		successText: "Sukces! Wysłaliśmy Ci kod weryfikacyjny, aby rozpocząć!",
		buttonText: "Poproś o kod weryfikacyjny"
	},
	errors: {
		notFound: "Nie znaleziono konta z tym adresem e-mail"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Nie pamiętasz hasła?",
	lead: "Jeśli musisz zresetować swoje hasło, wpisz poniżej swój adres e-mail, a my wyślemy Ci wiadomość, by rozpocząć ten proces.",
	resetTitle: "Resetuj hasło",
	resetLead: "Powinieneś otrzymać kod e-mailem. Wypełnij formularz, aby zresetować swoje hasło.",
	create: {
		title: "Utwórz hasło",
		lead: "Gratulujemy utworzenia Streamlabs ID! Jeszcze jeden krok i będziesz mieć możliwość logowania się we wszystkich serwisach Streamlabs!",
		resetTitle: "Wybierz hasło",
		resetLead: "Powinieneś otrzymać kod e-mailem. Użyj go i wypełnij formularz, aby ustawić swoje hasło."
	},
	successText: "Sukces! Przekierowywanie…",
	signInTitle: "Masz już konto?",
	signInBtn: "Zaloguj się"
};
var checkTfaCard = {
	title: "Kontrola uwierzytelniania dwuskładnikowego",
	lead: "Wprowadź kod 2FA poniżej, aby kontynuować.",
	successText: "Pomyślnie potwierdzono 2FA!",
	back: "Powrót"
};
var verifyEmailCard = {
	title: "Zweryfikuj swój e-mail",
	lead: "Sprawdź swoją pocztę, aby otrzymać 8-cyfrowy kod od Streamlabs i wpisz go poniżej.",
	back: "Powrót",
	successText: "Pomyślnie zweryfikowano e-mail!"
};
var upgradeCard = {
	confirm: {
		title: "Potwierdź połączenie z {company}",
		userLine: "<b>Streamlabs</b> {email}",
		items: [
			"W przyszłości możesz zalogować się do {company} za pomocą podanego adresu e-mail i hasła.",
			"Za pomocą swojego ID możesz uzyskać dostęp do wszystkich innych produktów Streamlabs i połączyć się z innymi istniejącymi kontami, jeśli takie posiadasz.",
			"Ta zmiana nie będzie miała wpływu na Twoje konto {company}."
		],
		button: "Potwierdź",
		cancel: "Anuluj",
		switchAccount: "Przełącz konto",
		success: "Łączenie…"
	},
	confirmed: {
		title: "Sukces!",
		subtitle: "Twoje Streamlabs ID zostało utworzone i konto {company} zostało podłączone.",
		text: "Możesz używać swojego Streamlabs ID dla wszystkich produktów Streamlabs. Jeśli masz istniejące konta, możesz je połączyć z tym ID z poziomu każdej aplikacji.",
		button: "Zamknij"
	},
	error: {
		user: "Niepowodzenia identyfikacji użytkownika. Spróbuj zalogować się ponownie lub skontaktuj się z pomocą techniczną."
	}
};
var confirmCard = {
	confirm: {
		title: "Potwierdź połączenie z {company}",
		subtitle: "Znaleźliśmy konto z pasującym adresem e-mail Czy chcesz scalić to konto ze Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Możesz zalogować się do {company} za pomocą podanego w Streamlabs ID adresu e-mail i hasła.",
			"Za pomocą swojego ID możesz uzyskać dostęp do wszystkich innych produktów Streamlabs i połączyć się z innymi istniejącymi kontami, jeśli takie posiadasz.",
			"Ta zmiana nie będzie miała wpływu na Twoje konto firmowe."
		],
		button: "Potwierdź",
		cancel: "Anuluj",
		switchAccount: "Przełącz konto",
		success: "Łączenie…"
	},
	confirmed: {
		title: "Sukces!",
		subtitle: "Twoje Streamlabs ID zostało utworzone i konto {company} zostało podłączone.",
		text: "Możesz używać swojego Streamlabs ID dla wszystkich produktów Streamlabs. Jeśli masz istniejące konta, możesz je połączyć z tym ID z poziomu każdej aplikacji.",
		button: "Zamknij"
	},
	error: {
		user: "Niepowodzenia identyfikacji użytkownika. Spróbuj zalogować się ponownie lub skontaktuj się z pomocą techniczną."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Twoje ID ma już połączone konto {company}",
		subtitle: "Czy chcesz odłączyć połączone konto i połączyć je z obecnym kontem Streamlabs?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Możesz zalogować się do Streamlabs za pomocą podanego w Streamlabs ID adresu e-mail i hasła.",
			"Za pomocą swojego ID możesz uzyskać dostęp do wszystkich innych produktów Streamlabs i połączyć się z innymi istniejącymi kontami, jeśli takie posiadasz.",
			"Ta zmiana nie będzie miała wpływu na Twoje konto Streamlabs."
		],
		button: "Potwierdź",
		cancel: "Anuluj",
		switchAccount: "Przełącz konto",
		success: "Łączenie…",
		agreeLabel: "Rozumiem, że dokonując tego połączenia, stracę dostęp do istniejącego konta {company}, które jest powiązane ze Streamlabs ID."
	},
	confirmed: {
		title: "Sukces!",
		subtitle: "Twoje Streamlabs ID zostało utworzone i konto {company} zostało podłączone.",
		text: "Możesz używać swojego Streamlabs ID dla wszystkich produktów Streamlabs. Jeśli masz istniejące konta, możesz je połączyć z tym ID z poziomu każdej aplikacji.",
		button: "Zamknij"
	},
	error: {
		user: "Niepowodzenia identyfikacji użytkownika. Spróbuj zalogować się ponownie lub skontaktuj się z pomocą techniczną."
	}
};
var loginCard = {
	title: "Zaloguj się",
	lead: "Zaloguj się do <company>{company}</company> za pomocą <id>Streamlabs ID</id>",
	accountExists: "Wygląda na to, że masz <b>Streamlabs ID</b>. Spróbuj zalogować się za pomocą e-maila.",
	forgotPassword: "Nie pamiętasz hasła?",
	successText: "Sukces! Przekierowywanie…",
	signInTitle: "Zaloguj się za pomocą platformy"
};
var loginSourcesCard = {
	title: "Zaloguj się",
	lead: "Zaloguj się za pomocą e-maila/hasła",
	withSlId: "Zaloguj się za pomocą Streamlabs ID",
	noAccountMessage: "Nie widzimy konta powiązanego z tą metodą logowania. Spróbuj innej metody logowania lub <signup>Zarejestruj się</signup>, jeśli jeszcze tego nie zrobiłeś.",
	accountExistsMessage: "Twój adres e-mail w na Twitchu jest już powiązany z adresem w Streamlabs. Spróbuj zalogować się, używając swojego adresu e-mail i hasła Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mail",
	codePlaceholder: "6-8-cyfrowy kod e-mail",
	tfaCodePlaceholder: "Kod 2FA",
	newPasswordPlaceholder: "Nowe hasło",
	tfaError: "Kod resetowania powinien zawierać od 6 do 10 znaków",
	next: "Otrzymałeś kod?",
	back: "Powrót do strony „Nie pamiętam hasła”",
	buttonText: "Zmień hasło",
	successText: "Pomyślnie zresetowano hasło",
	create: {
		back: "Powrót do początku",
		buttonText: "Ustaw hasło",
		successText: "Pomyślnie ustawiono hasło"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Obecne hasło",
	newPasswordPlaceholder: "Nowe hasło",
	newPasswordConfirmationPlaceholder: "Potwierdź nowe hasło",
	buttonText: "Zmień hasło",
	successText: "Pomyślnie zaktualizowano hasło",
	newPasswordConfirmationError: "Nowe hasła nie są identyczne",
	back: "Powrót do panelu kontrolnego"
};
var changePasswordCard = {
	title: "Zmień hasło",
	lead: "Wprowadź obecne hasło oraz nowe hasło poniżej.",
	successText: "Pomyślnie zaktualizowano hasło"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-cyfrowy kod uwierzytelniający/8-cyfrowy kod zapasowy",
	successText: "Pomyślnie usunięto 2FA",
	removeBtn: "Potwierdź i usuń"
};
var removeTfaCard = {
	title: "Usuń uwierzytelnianie dwuskładnikowe",
	lead: "Wpisz poniżej kod potwierdzenia 2FA, aby usunąć z konta uwierzytelnianie dwuskładnikowe.",
	successText: "Pomyślnie usunięto 2FA",
	back: "Powrót do panelu kontrolnego"
};
var verifyEmailForm = {
	codePlaceholder: "8-cyfrowy kod z e-maila",
	tfaCodePlaceholder: "Kod 2FA",
	emailPlaceholder: "Adres e-mail",
	buttonText: "Zweryfikuj e-mail",
	successText: "Pomyślnie zweryfikowano e-mail",
	requestBtn: "Poproś o nowy kod",
	requestingBtn: "Prośba…",
	requestSuccess: "Kod został wysłany na Twój adres e-mail",
	requestAgain: "Poproś ponownie za {seconds} s",
	tfaError: "Kod resetowania powinien zawierać od 6 do 10 znaków",
	back: "Powrót"
};
var signupCard = {
	title: "Zarejestruj się",
	lead: "Utwórz konto <id>Streamlabs ID</id>, aby używać <company>{company}</company>",
	successText: "Sukces! Przekierowywanie…"
};
var signupSourcesCard = {
	title: "Zarejestruj się",
	lead: "Utwórz konto <id>Streamlabs ID</id>, aby używać <company>{company}</company>",
	withSlId: "Utwórz Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Wybierz konto",
		lead: "aby kontynuować w <b>{company}</b>",
		authorize: "Autoryzuj",
		authorizeSuccess: "Sukces!",
		cancel: "Anuluj",
		disclaimer: {
			streamlabs: "Kontynuując, udostępnisz swój Streamlabs ID (Twoje imię i nazwisko, adres e-mail, preferencje językowe i zdjęcie profilowe) <b>{company}</b>. Autoryzując konto z <b>{company}</b>, niniejszym akceptujesz <privacy>politykę prywatności</privacy> i <terms>warunki korzystania z usług</terms> <b>{company}</b>.",
			"default": "Aby kontynuować, Streamlabs udostępni Twoje imię i nazwisko, adres e-mail, preferencje językowe i zdjęcie profilowe <b>{company}</b>. Autoryzując konto z <b>{company}</b>, niniejszym akceptujesz <privacy>politykę prywatności</privacy> i <terms>warunki korzystania z usług</terms> <b>{company}</b>."
		},
		emailRequired: "Weryfikacja e-mail wymagana przed kontynuacją",
		tfaRequired: "Weryfikacja uwierzytelnienia dwuskładnikowego wymagana przed kontynuacją"
	},
	login: {
		title: "Zaloguj się do {company}",
		lead: "Musisz się zalogować, aby łączyć konta",
		loginBtn: "Przejdź do logowania"
	},
	error: {
		title: "Zaloguj się do {company}",
		lead: "Twojej prośby nie można teraz autoryzować.",
		verifyEmail: "Zweryfikuj e-mail",
		verify2fa: "Weryfikacja 2FA"
	},
	"switch": {
		btn: "Użyj innego konta"
	}
};
var appsDropdown = {
	label: "Produkty i aplikacje Streamlabs",
	viewMore: "Rozwiń",
	viewLess: "Zwiń"
};
var platformButtons = {
	loginWithPlatform: "Zaloguj się za pomocą platformy",
	signUpWithPlatform: "Zarejestruj się za pomocą platformy",
	signUpLead: "Obsługujemy streaming na żywo na wielu innych platformach, to są tylko opcje rejestracji."
};
var ultraCheckoutCard = {
	title: "Podnieś poziom swoich transmisji, brandingu, montażu i nie tylko za sprawą <b>Streamlabs Ultra</b>",
	badge: "Obejmuje <b>{planName}</b>",
	totalValue: "{price, currency} wartość",
	price: {
		month: "{price, currency}/mies.",
		year: "{price, currency}/rok"
	},
	description: {
		month: "Zyskaj funkcje premium w całym pakiecie, w tym <b>Streamlabs Desktop</b>, <b>Konsolę</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> i wiele więcej, dostępnych od razu i w uczciwej cenie.",
		year: "Zyskaj funkcje premium w całym pakiecie, w tym <b>Streamlabs Desktop</b>, <b>Konsolę</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> i wiele więcej, dostępnych od razu i w uczciwej cenie."
	},
	seeIncluded: "Dowiedz się więcej",
	buyNow: "Ulepsz"
};
var ultraCheckoutBanner = {
	title: "Podnieś poziom swoich transmisji, brandingu, montażu i nie tylko za sprawą <b>Streamlabs Ultra</b>",
	badge: "Obejmuje <b>{planName}</b>",
	totalValue: "{price, currency} wartość",
	price: {
		month: "{price, currency}/mies.",
		year: "{price, currency}/rok"
	},
	description: {
		month: "Zyskaj funkcje premium w całym pakiecie, w tym <b>Streamlabs Desktop</b>, <b>Konsolę</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> i wiele więcej, dostępnych od razu i w uczciwej cenie. <link />",
		year: "Zyskaj funkcje premium w całym pakiecie, w tym <b>Streamlabs Desktop</b>, <b>Konsolę</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> i wiele więcej, dostępnych od razu i w uczciwej cenie. <link />"
	},
	seeIncluded: "Dowiedz się więcej",
	buyNow: "Ulepsz"
};
var connect = {
	waitMessage: "Łączenie danych. Nie zamykaj tego okna."
};
var verifyPasswordCard = {
	success: "Pomyślnie zweryfikowano hasło",
	title: "Uwierzytelnij się ponownie, aby zweryfikować",
	lead: "Zaloguj się przy użyciu istniejącego adresu e-mail i hasła, aby kontynuować aktualizację Streamlabs ID.",
	buttonText: "Dalej"
};
var emailChangeForm = {
	agreeError: "Sprawdź, czy rozumiesz to działanie",
	buttonText: "Dalej",
	emailPlaceholder: "Nowy adres e-mail",
	agreeText: "Rozumiem, że po weryfikacji mój Streamlabs ID zmieni się we wszystkich produktach Streamlabs, z którymi jest połączony."
};
var verifyNewEmailCard = {
	title: "Wybierz swój Streamlabs ID",
	lead: "Podaj nowy adres e-mail, który będzie używany jako Streamlabs ID. Wyślemy na ten adres 6–8 cyfrowy kod weryfikacyjny.",
	successText: "Nowy e-mail dostępny"
};
var verifyNewEmailOwnershipCard = {
	title: "Zweryfikuj zaktualizowany Streamlabs ID.",
	lead: "Sprawdź swoją pocztę, aby otrzymać 8-cyfrowy kod od Streamlabs i wpisz go poniżej.",
	buttonText: "Potwierdź",
	back: "Cofnij",
	codePlaceholder: "8-cyfrowy kod z e-maila",
	successText: "Pomyślnie zweryfikowano własność konta e-mail"
};
var verifyTfaCard = {
	title: "Kod uwierzytelniania dwuskładnikowego",
	lead: "Wprowadź 6-cyfrowy kod weryfikacyjny z aplikacji uwierzytelniającej.",
	codePlaceholder: "6-cyfrowy kod",
	buttonText: "Potwierdź",
	successText: "Potwierdzono uwierzytelnianie dwuskładnikowe",
	back: "Cofnij"
};
var ageGateForm = {
	ageLabel: "Data urodzenia",
	agePlaceholder: "MM.DD.RRRR"
};
var ageGateCard = {
	title: "Zakończ konfigurację konta",
	lead: {
		years: "Musisz mieć co najmniej {years} lat, aby utworzyć konto. <br />Wprowadź swoją datę urodzenia, aby zakończyć konfigurację.",
		noYears: "Aby utworzyć konto, musisz podać swoją datę urodzenia. <br />Wprowadź, aby dokończyć konfigurację."
	},
	successText: "Gratulacje! Zakończ konfigurację konta."
};
var plPL = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { plPL as p };
//# sourceMappingURL=pl-PL.es.js.map
